import { useEffect, useState } from 'react';

let switching = false;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());

export const beginClientSwitch = () => {
  if (switching) return;
  switching = true;
  notify();
};

export const endClientSwitch = () => {
  if (!switching) return;
  switching = false;
  notify();
};

export const isClientSwitching = (): boolean => switching;

let signingOut = false;

export const beginSignOut = () => {
  signingOut = true;
};

export const endSignOut = () => {
  signingOut = false;
};

export const isSigningOut = (): boolean => signingOut;

export const useIsClientSwitching = (): boolean => {
  const [value, setValue] = useState(switching);
  useEffect(() => {
    const listener = () => setValue(switching);
    listeners.add(listener);
    listener();
    return () => {
      listeners.delete(listener);
    };
  }, []);
  return value;
};
